module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAPBJREFUKFNlkMFKw1AQRc9MvsetKxG0SRQsIupLowtRELvzF6p/4LILERGR5olUsIimEXTjxp3/k/cklaaNzm7mHriHEebHFhG4KwI9Yics5iOpl0HRRso70EtwxyApnfh5mv+C9+NtnLtGg31MOMLmmyC3qBywGz5WiJDle0AfxWDivG6wL+t4zRA9IQmzCvxApYeJ3rFvi7iyD9olDb+wr6ugZyTR8szRjpfAPyE6wrs2EmxgWp9Nx4dihdIPEU4x0Q02P8RzgcrWpGniOHXxvku6Nqgd/7hXjt9I0CNpDRs/rb/hz+nECzPHf1Tz8APQhVMLVuySHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/up.png
// module id = /B2o
// module chunks = 0